// The backend (bynder-lucee / pybynder) seeds `<meta name="bynder.feature_flag.<name>"
// content="<treatment>">` into `<head>`: a sync read for the first render, unlike async `useSplit`.
export const FEATURE_FLAG_META_PREFIX = 'bynder.feature_flag.';

/** Anything but `on` — including the flag not being seeded at all — is off. */
export const isSeededFeatureFlagOn = (name: string): boolean =>
	document
		.querySelector(`meta[name="${FEATURE_FLAG_META_PREFIX}${name}"]`)
		?.getAttribute('content') === 'on';
